import React, { useEffect, useState } from 'react';

import styles from './Animated.module.scss';

type AnimatedProps = {
	animationIn?: string;
	animationOut?: string;
	animationInDuration?: number;
	animationOutDuration?: number;
	isVisible?: boolean;
	className?: string;
	style?: React.CSSProperties;
	children: React.ReactNode;
};

// Inspired by the react-animated-css library:
// https://github.com/daneden/react-animated-css
const Animated = ({
	animationIn = 'fadeIn',
	animationOut = 'fadeOut',
	animationInDuration = 1000,
	animationOutDuration = 1000,
	isVisible = true,
	className = '',
	style = {},
	children
}: AnimatedProps) => {
	const [shouldRender, setShouldRender] = useState(isVisible);
	const [animationClass, setAnimationClass] = useState('');

	useEffect(() => {
		if (isVisible) {
			setShouldRender(true);
			setAnimationClass(animationIn);
		} else {
			setAnimationClass(animationOut);
			// Remove from DOM after animation completes
			const timeout = setTimeout(() => {
				setShouldRender(false);
			}, animationOutDuration);
			return () => clearTimeout(timeout);
		}
	}, [isVisible, animationIn, animationOut, animationOutDuration]);

	if (!shouldRender) {
		return null;
	}

	const animationDuration = isVisible ? animationInDuration : animationOutDuration;

	return (
		<div
			className={`${styles.animated} ${styles[animationClass]} ${className}`}
			style={{
				...style,
				animationDuration: `${animationDuration}ms`
			}}
		>
			{children}
		</div>
	);
};

export default Animated;
